import React from 'react';
import { Button, Form, FormFeedback, FormGroup, Input, Label, ModalBody, ModalFooter, Row } from 'reactstrap';

export const FormCurveTime = (props) => {

    const {
        button, loading, handleInputChange, validations, time_in_minutes, label, methodAction, closeModalCurves

    } = props;

    const {
        label_valid,
        time_valid,

    } = validations;


    return (
        <Form className="" role="form" onSubmit={methodAction}>
            <Row>
                <FormGroup className="mb-3 col-6">
                    <Label className="col-form-label" >Nombre del tiempo <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                    <Input
                        type="text"
                        name="label"
                        value={label}
                        onChange={handleInputChange}
                        invalid={label_valid}
                        className="form-control form-control-sm input-air-primary"
                        autoComplete="nope"

                    />
                    <FormFeedback>El nombre debe tener 3 o más caracteres</FormFeedback>
                </FormGroup>
                <FormGroup className="mb-3 col-6 ">
                    <Label className="col-form-label">Tiempo en minutos <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                    <Input
                        type="number"
                        name="time_in_minutes"
                        value={time_in_minutes}
                        onChange={handleInputChange}
                        invalid={time_valid}
                        className="form-control form-control-sm input-air-primary"
                        autoComplete="nope"

                    />
                    <FormFeedback>El tiempo no puede estar vacío</FormFeedback>
                </FormGroup>

            </Row>

        </Form>
    )
}
